export const FETCH_MESSAGES_REQUEST = "FETCH_MESSAGES_REQUEST";
export const FETCH_MESSAGES_SUCCESS = "FETCH_MESSAGES_SUCCESS";
export const FETCH_MESSAGES_FAILURE = "FETCH_MESSAGES_FAILURE";
export const APPEND_NEW_MESSAGE = "APPEND_NEW_MESSAGE";
export const UPDATE_MESSAGE_STATE = "UPDATE_MESSAGE_STATE";
export const UPDATE_MESSAAGE = "UPDATE_MESSAAGE";
